import { render, staticRenderFns } from "./warehouses.vue?vue&type=template&id=046ef642&scoped=true&"
import script from "./warehouses.vue?vue&type=script&lang=js&"
export * from "./warehouses.vue?vue&type=script&lang=js&"
import style0 from "./warehouses.vue?vue&type=style&index=0&id=046ef642&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ef642",
  null
  
)

/* custom blocks */
import block0 from "./warehouses.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports